import { render, staticRenderFns } from "./ZohoForwardSettings.vue?vue&type=template&id=d2314886&scoped=true"
import script from "./ZohoForwardSettings.vue?vue&type=script&lang=js"
export * from "./ZohoForwardSettings.vue?vue&type=script&lang=js"
import style0 from "./ZohoForwardSettings.vue?vue&type=style&index=0&id=d2314886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2314886",
  null
  
)

export default component.exports